(function () {
  function updateCartVisibility() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.documentElement.classList.toggle('cart-has-items', cart.item_count > 0);
      });
  }

  updateCartVisibility();

  document.addEventListener('cart:updated', updateCartVisibility);
  document.addEventListener('shopify:section:load', updateCartVisibility);
})();
